import store from "@/store";
import {
  VuexModule,
  Module,
  Action,
  Mutation,
  getModule,
} from "vuex-module-decorators";
import api from "@/api";
import NewNotificationModel from "@/models/NewNotificationModel";

export interface INotificationState {
  newNotification: number;
}
@Module({ dynamic: true, store, name: "notification" })
class Notification extends VuexModule {
  public countNewNotif: NewNotificationModel = new NewNotificationModel();

  @Mutation
  private SET_NEW_NOTIFICATION(countNewNotif: NewNotificationModel) {
    this.countNewNotif = countNewNotif;
  }

  @Action({ rawError: true })
  public LoadCountNotif() {
    return new Promise((resolve, reject) => {
      api.notification.getCountNewNotif().then((response) => {
        if (response.data.code === 200) {
          this.SET_NEW_NOTIFICATION(response.data.data);
          resolve(response);
        } else {
          reject(new Error(response.data.message));
        }
      });
    });
  }
}
export const NotificationModule = getModule(Notification);
